import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class EnvInterceptor implements HttpInterceptor {
  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const env = sessionStorage.getItem('env');
    if (env) {
      const clonedRequest = req.clone({
        setHeaders: {
          Environment: env,
        },
      });
      return next.handle(clonedRequest);
    }

    return next.handle(req);
  }
}
